import React from 'react';
import Box from '@mui/material/Box';
import { SimTypography } from 'components/SimTypography';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';
import { useTheme } from '@mui/material/styles';

import SimContainer from 'components/SimContainer';

const mock = [
	{
		label: 'Phone',
		value: '+1.469.269.0616',
		icon: (
			<svg width={20} height={20} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='currentColor'>
				<path d='M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z' />
			</svg>
		)
	},
	{
		label: 'Email',
		value: 'contact@simsouls.com',
		icon: (
			<svg width={20} height={20} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='currentColor'>
				<path d='M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z' />
				<path d='M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z' />
			</svg>
		)
	},
	{
		label: 'Address',
		value: '4087 Guadalupe Ln, Frisco, TX 75034, USA',
		icon: (
			<svg width={20} height={20} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='currentColor'>
				<path
					fillRule='evenodd'
					d='M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z'
					clipRule='evenodd'
				/>
			</svg>
		)
	},
	{
		label: 'Whatsapp',
		value: '+1.469.269.0616',
		icon: (
			<svg width={20} height={20} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='currentColor'>
				<path d='M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z' />
			</svg>
		)
	}
];

const ContactDetails = () => {
	const theme = useTheme();

	const LeftSide = () => {
		return (
			<Box paddingY={0}>
				<Box marginBottom={2} marginTop={2}>
					<SimTypography
						sx={{
							textTransform: 'uppercase',
							fontWeight: 'medium'
						}}
						gutterBottom
						color={'secondary'}
						align={'left'}>
						Contact details
					</SimTypography>

					<SimTypography
						color={theme.palette.text.headerLight}
						variant='h4'
						align={'left'}
						data-aos={'fade-up'}
						gutterBottom
						sx={{
							fontWeight: 700
						}}>
						We look forward to <br /> connecting with you
					</SimTypography>
				</Box>

				<Box display={'flex'} flexDirection={'column'} justifyContent={'space-between'}>
					{mock.map((item, i) => (
						<Box key={i} component={ListItem} width={'auto'} padding={1}>
							<Box component={ListItemAvatar} minWidth={'auto !important'} marginRight={2}>
								<Box component={Avatar} bgcolor={theme.palette.secondary.main} width={40} height={40}>
									{item.icon}
								</Box>
							</Box>
							<ListItemText
								primary={
									<SimTypography
										marginY={0}
										variant='h6'
										color={theme.palette.secondary.main}
										fontWeight={500}>
										{' '}
										{item.label}{' '}
									</SimTypography>
								}
								secondary={
									<SimTypography variant='p' color={theme.palette.text.bodyLight} fontWeight={300}>
										{' '}
										{item.value}{' '}
									</SimTypography>
								}
							/>
						</Box>
					))}
				</Box>
			</Box>
		);
	};

	const RightSide = () => {
		return (
			<iframe
				width='100%'
				height='100%'
				frameBorder='0'
				title='map'
				marginHeight={0}
				marginWidth={0}
				scrolling='no'
				/* src="https://maps.google.com/maps?width=100%&height=100%&hl=en&q=Milan&ie=UTF8&t=&z=14&iwloc=B&output=embed" */

				src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3341.729249701475!2d-96.85572828480929!3d33.11620118087094!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864c3b9e31f0afa5%3A0x863ae038bc27e59e!2s4087%20Guadalupe%20Ln%2C%20Frisco%2C%20TX%2075034%2C%20USA!5e0!3m2!1sen!2sin!4v1674039945022!5m2!1sen!2sin'
				style={{
					minHeight: 300,
					filter: theme.palette.mode === 'dark' ? 'grayscale(0.5) opacity(0.7)' : 'none'
				}}
			/>
		);
	};

	return (
		<Box
			sx={{
				width: 1,
				height: 1,
				overflow: 'hidden'
			}}>
			<SimContainer paddingX={0} paddingY={0} maxWidth={{ sm: 1, md: 1236 }}>
				<Box display={'flex'} flexDirection={{ xs: 'column', md: 'row' }} position={'relative'}>
					<Box display={'flex'} alignItems={'center'} width={1} order={{ xs: 2, md: 1 }}>
						<SimContainer>
							<LeftSide />
						</SimContainer>
					</Box>
					<Box
						sx={{
							flex: { xs: '0 0 100%', md: '0 0 50%' },
							position: 'relative',
							maxWidth: { xs: '100%', md: '50%' },
							minHeight: { xs: 300, md: 600 },
							order: { xs: 1, md: 2 }
						}}>
						<Box
							sx={{
								width: { xs: 1, md: '50vw' },
								height: '100%',
								position: 'relative'
							}}>
							<Box
								marginLeft={{ xs: '2', sm: '2' }}
								sx={{
									width: '100%',
									height: '100%',
									overflow: 'hidden'
								}}>
								<Box
									paddingRight={{ xs: 2, sm: 2, md: 2, lg: 3 }}
									paddingLeft={{ xs: 2, sm: 2, md: 2, lg: 3 }}
									paddingTop={2}
									paddingBottom={2}
									sx={{
										overflow: 'hidden',
										left: '0%',
										width: 1,
										height: 1,
										position: { xs: 'relative', md: 'absolute' }
									}}>
									<RightSide />
								</Box>
							</Box>
						</Box>
					</Box>
				</Box>
			</SimContainer>
			<Divider />
		</Box>
	);
};

export default ContactDetails;
